import CamelCaseString from "../../Common/CamelCaseString";
import userService from "../../services/user.service";
import { ActionTypes } from "../Constants/ActionTypes";

export const getTeamAdminPermissions = (dispatch, payload) => {
  userService
    .getAllPermissions()
    .then((res) => {
      const rights = res.data.data.filter((item) => item.id != 5);
      dispatch({
        type: ActionTypes.GET_TEAM_ADMIN_PERMISSIONS,
        payload: rights,
      });
    })
    .catch(() => {
      dispatch({
        type: ActionTypes.OPEN_FAIL_DIALOG,
        payload: {
          open: true,
          message: "Something Went Wrong.",
        },
      });
    });
};

export const selectOrRemoveTeamAdminPermissions = (dispatch, payload) => {
  dispatch({
    type: ActionTypes.SELECT_UNSELECT_TEAM_ADMIN_PERMISSIONS,
    payload: payload,
  });
};

export const addTeamAdmin = (dispatch, payload) => {
  const {
    uploadId,
    firstName,
    lastName,
    email,
    phoneNumber,
    speciality,
    groupIds,
    schoolId,
    permissionRights,
    sportsIds,
    currentUserId,
  } = payload;
  dispatch({
    type: ActionTypes.TEAM_ADMIN_LOADING,
    payload: {
      pageLoading: false,
      buttonLoading: true,
    },
  });
  userService
    .addTeamAdmin(
      uploadId,
      firstName,
      lastName,
      email,
      phoneNumber,
      speciality,
      groupIds,
      schoolId,
      permissionRights,
      sportsIds
    )
    .then((res) => {
      if (res.status == 200 && res.data.status === true) {
        const memberId = res.data.data.id;
        const type = "MEMBER_ADDED";
        const isOnPage = "true";
        const pageName = "CELL";
        userService.addActivityMemberAdded(
          memberId,
          schoolId,
          currentUserId,
          isOnPage,
          pageName,
          type,
          uploadId
        );
        dispatch({
          type: ActionTypes.OPEN_SUCCESS_POPUP,
          payload: {
            successPopUp: {
              message: "Team Admin Added Successfully",
              open: true,
              navigationLink: `/teamadmin`,
            },
          },
        });
      } else {
        dispatch({
          type: ActionTypes.OPEN_FAIL_DIALOG,
          payload: {
            open: true,
            message: CamelCaseString(res.data?.message),
          },
        });
      }
      dispatch({
        type: ActionTypes.TEAM_ADMIN_LOADING,
        payload: {
          pageLoading: false,
          buttonLoading: false,
        },
      });
    })
    .catch((err) => {
      dispatch({
        type: ActionTypes.OPEN_FAIL_DIALOG,
        payload: {
          open: true,
          message: "Something Went Wrong.",
        },
      });
      dispatch({
        type: ActionTypes.TEAM_ADMIN_LOADING,
        payload: {
          pageLoading: false,
          buttonLoading: false,
        },
      });
    });
};

export const updateTeamAdmin = (dispatch, payload) => {
  const {
    uploadId,
    firstName,
    lastName,
    email,
    phoneNumber,
    speciality,
    groupIds,
    schoolId,
    permissionRights,
    sportsIds,
    id,
  } = payload;
  dispatch({
    type: ActionTypes.TEAM_ADMIN_LOADING,
    payload: {
      pageLoading: false,
      buttonLoading: true,
    },
  });
  userService
    .editTeamAdmin(
      id,
      uploadId,
      CamelCaseString(firstName),
      CamelCaseString(lastName),
      email,
      phoneNumber,
      speciality,
      groupIds,
      schoolId,
      permissionRights,
      sportsIds
    )
    .then(() => {
      dispatch({
        type: ActionTypes.TEAM_ADMIN_LOADING,
        payload: {
          pageLoading: false,
          buttonLoading: false,
        },
      });
      dispatch({
        type: ActionTypes.OPEN_SUCCESS_POPUP,
        payload: {
          successPopUp: {
            message: "Team Admin Updated Successfully.",
            open: true,
            navigationLink: `/teamadmindetails/${id}`,
          },
        },
      });
    })
    .catch(() => {
      dispatch({
        type: ActionTypes.OPEN_FAIL_DIALOG,
        payload: {
          open: true,
          message: "Something Went Wrong.",
        },
      });
      dispatch({
        type: ActionTypes.TEAM_ADMIN_LOADING,
        payload: {
          pageLoading: false,
          buttonLoading: false,
        },
      });
    });
};

export const getTeamAdminSpeciality = (dispatch) => {
  userService.getSpecialtyDropdown().then((res) => {
    dispatch({
      type: ActionTypes.GET_ALL_TEAM_ADMIN_SPECIALITY,
      payload: res.data.data,
    });
  });
};

export const handleTeamAdminLogoUpload = (dispatch, payload) => {
  const data = new FormData();
  data.append("file", payload.file);
  data.append("userId", payload.currentUserId);
  dispatch({
    type: ActionTypes.TEAM_ADMIN_LOADING,
    payload: {
      pageLoading: false,
      buttonLoading: false,
      profileImageLoading: true,
    },
  });
  userService
    .postLogoForAll(data)
    .then((res) => {
      const { filePath, id } = res.data.data;
      dispatch({
        type: ActionTypes.HANDLE_TEAM_ADMIN_LOGO_UPLOAD,
        payload: { filePath, id },
      });
      dispatch({
        type: ActionTypes.TEAM_ADMIN_LOADING,
        payload: {
          pageLoading: false,
          buttonLoading: false,
          profileImageLoading: false,
        },
      });
    })
    .catch(() => {
      dispatch({
        type: ActionTypes.TEAM_ADMIN_LOADING,
        payload: {
          pageLoading: false,
          buttonLoading: false,
          profileImageLoading: false,
        },
      });
    });
};

export const getTeamAdminData = (dispatch, payload) => {
  dispatch({
    type: ActionTypes.TEAM_ADMIN_LOADING,
    payload: {
      pageLoading: true,
      buttonLoading: false,
    },
  });
  userService.getTeamAdminById(payload.id).then((res) => {
    const { uploadedLogo, permissionsRights, groupAdminResponses } =
      res.data.data;
    const newGroupResponse = groupAdminResponses?.map(
      ({ name: groupName, ...rest }) => ({
        groupName,
        ...rest,
      })
    );
    dispatch({
      type: ActionTypes.GET_TEAM_ADMIN_DATA,
      payload: res.data.data,
    });
    dispatch({
      type: ActionTypes.HANDLE_TEAM_ADMIN_LOGO_UPLOAD,
      payload: { filePath: uploadedLogo?.filePath, id: uploadedLogo?.id },
    });
    dispatch({
      type: ActionTypes.SELECT_UNSELECT_TEAM_ADMIN_PERMISSIONS,
      payload: permissionsRights ? permissionsRights : [],
    });
    dispatch({
      type: ActionTypes.SET_SELECTED_GROUPS_LIST,
      payload: newGroupResponse ? newGroupResponse : [],
    });
    dispatch({
      type: ActionTypes.TEAM_ADMIN_LOADING,
      payload: {
        pageLoading: false,
        buttonLoading: false,
      },
    });
  });
};

export const setTeamAdminSpeciality = (dispatch, payload) => {
  dispatch({
    type: ActionTypes.SET_TEAM_ADMIN_SPECIALITY,
    payload: payload,
  });
};

export const resetTeamAdminData = (dispatch, payload) => {
  dispatch({
    type: ActionTypes.RESET_TEAM_ADMIN_DATA,
    payload: payload,
  });
};

export const deleteTeamAdmin = (dispatch, payload) => {
  userService
    .deleteTeamAdmin([payload.id])
    .then(() => {
      dispatch({
        type: ActionTypes.CLOSE_CONFIRMATION_POPUP,
        payload: false,
      });
      dispatch({
        type: ActionTypes.DELETE_TEAM_ADMIN,
        payload: payload,
      });
      dispatch({
        type: ActionTypes.OPEN_SUCCESS_POPUP,
        payload: {
          successPopUp: {
            message: "Team Admin Deleted Successfully.",
            open: true,
          },
        },
      });
    })
    .catch(() => {
      dispatch({
        type: ActionTypes.OPEN_FAIL_DIALOG,
        payload: {
          open: true,
          message: "Something Went Wrong.",
        },
      });
      dispatch({
        type: ActionTypes.CLOSE_CONFIRMATION_POPUP,
        payload: false,
      });
    });
};

export const activateInactivateTeamAdmin = (dispatch, payload) => {
  userService
    .getStatusTeamAdmin(payload.id, payload.status)
    .then((response) => {
      if (response.data.success == true) {
        dispatch({
          type: ActionTypes.ACTIVATE_INACTIVATE_TEAM_ADMIN,
          payload: payload.status,
        });
        dispatch({
          type: ActionTypes.CLOSE_CONFIRMATION_POPUP,
          payload: false,
        });
        dispatch({
          type: ActionTypes.OPEN_SUCCESS_POPUP,
          payload: {
            successPopUp: {
              message: `Team Admin ${
                payload.status ? "Activated" : "Deactivated"
              } Successfully.`,
              open: true,
            },
          },
        });
      }
    })
    .catch((error) => {
      console.error("There was an error!", error);
    });
};
